// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.piq-body {
    margin: 0;
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #515151;
    text-align: left;
    background-color: #010148;
    min-height: 100vh;
}

/* Signup and Singin */

.piq-body .card-rounded{
    border-radius: 15px;
}

.piq-body .input-rounded{
    border-radius: 8px;
    background-color: #f8f8f8;

}

.piq-body .button-rounded{
    border-radius: 8px;
    background-color: #4040dd;

}

.piq-body .anchor-button-color{
    color: #4040dd;
    text-decoration: none;
}

.piq-body .anchor-color{
    color: #4040dd;
}

.piq-body .contactInfo-btn-rounded-circle{
    border: 3px solid black;
    border-radius: 50px;
    font-size: 7px;
    margin-top: 10px;
    margin-right: 10px;
    padding: 6px;
}
.piq-body .contactInfo-btn-rounded-circle.btn-close {
    opacity: 1;
}


/* dashboard */
/*
.piq-body nav {
    display: block;
}

.piq-body h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
}

.piq-body p {
    margin-top: 0;
    margin-bottom: 1rem;
}

.piq-body a {
    color: #3f84fc;
    text-decoration: none;
    background-color: transparent;
}

.piq-body a:hover {
    color: #0458eb;
    text-decoration: underline;
} */
/*
.piq-body h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    font-family: "IBM Plex Sans", sans-serif;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.2;
}

.piq-body h1, .h1 {
    font-size: 2.5rem;
    font-weight: normal;
} */





/* .piq-body .dashboard-app .card {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0;
} */

/* .piq-body .card-body {
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem;
}

.piq-body .card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(0, 0, 0, 0.03);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    text-align: center;
} */

.piq-body .dashboard {
    display: flex;
    min-height: 100vh;
	flex-direction: column;
}

.piq-body .dashboard-app {
    display: flex;
    flex-direction: column;
    flex-grow: 2;
    background: white;
    border-radius: 30px 0px 0px 30px;
}

/* .dashboard-content {
    flex-grow: 2;
    padding: 25px;
} */

.piq-body .dashboard-nav {
    min-width: 238px;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    overflow: auto;
    background-color: #010148;
    display: flex;
    flex-direction: column;
}

.piq-body .dashboard-toolbar,
.piq-body .brand-logo,
.piq-body .dashboard-nav-list:not(.sign-out-nav) {
    flex-shrink: 0;
}
.piq-body .dashboard-nav-list.sign-out-nav {
    margin-top: auto;
}

/* .piq-body .dashboard-compact .dashboard-nav {
    display: none;
} */

.piq-body .dashboard-nav header {
    display: flex;
    justify-content: center;
    width: 14px;
}

/* .piq-body .dashboard-nav header .piq-body .dashboard-app .menu-toggle {
    display: none;
    margin-right: auto;
} */

.piq-body .dashboard-nav a {
    color: #fff;
    text-decoration: none;
}

.piq-body .dashboard-nav a:hover {
    text-decoration: none;
}





.piq-body .campaignInfo-ok-btn{
    color: #fff;
    background-color: #110F75;
    padding: 5px 20px 5px 20px;
    text-align: center;
    border-radius: 7px;
    border:2px solid #110F75;
    font-weight: 700;
}

.piq-body .uploadCsv-modalContent{
    background-color: #010148 ;
    border-radius: 5px !important;
}

.piq-body .uploadCsv-input-rounded{
    font-weight: 500;
    border: none;
    color: #797979;
	cursor:pointer;
}

.piq-body .uploadCsv-file-label{
    font-weight: 400;
    color: #ffff;
}



.piq-body .campaignInfo-modalContent{
    border: 4px solid #2c3e7e !important;
    border-radius: 20px !important;
}

.piq-body .campaignInfo-modalLabel{
    font-size: 14px;
    font-weight: 600;
}

.piq-body .campaignInfo-save-btn{
    background-color: #5BE7CD;
    color: #1c1c1c;
    padding-left: 20px;
    padding-right: 20px;
    font-weight: 500;
    border: 1px solid #5BE7CD;
}

.piq-body .campaignInfo-btn-rounded-circle{
    border: 3px solid #2c3e7e !important;
    border-radius: 50px !important;
    font-size: 7px !important;
    margin-top: 10px !important;
    margin-right: 10px !important;
    padding: 6px !important;
}
.piq-body .campaignInfo-btn-rounded-circle.btn-close {
    opacity: 1 !important;
}






/* .piq-body .dashboard-nav {
    background-color: #010148;

} */

.piq-body .dashboard-app .status-pill
{
    font-weight: 700;
    font-size: 14px;
    display: inline-block;
    min-width: 150px;
}

.piq-body .dashboard-app .button-bg-warning-danger{
    background-color: #F55F6E;
}
.piq-body .dashboard-app .button-bg-warning{
    background-color: #F5A065;
}
.piq-body .dashboard-app .button-bg-info{
    background-color: #5BE7CD;
}

.piq-body .dashboard-app .cl-filter-icon label{
    font-weight: 600;
}

.piq-body .dashboard-app .cl-filter-icon span img
{
    max-width: 26px;
    border-radius: 8px;
    margin-right: 7px;
}

.piq-body .dashboard-app .cl-internal-area-container{
    background-color:#f2f5fa;
    border-radius: 15px;
    min-height: calc(100vh - 220px);
}

.piq-body .dashboard-app .cl-heading-border {
    border: 0;
    height: 4px !important;
    background: linear-gradient(to right, #6caad9 28%, #b0c8df 28%);
    margin: 10px 0;
    opacity: 1;
}

.piq-body .dashboard-app .share-square-btn{
    border: none;
    padding: 0;
    color:#4AA2E9;
    background-color:#f5f5f5;
}

.piq-body .dashboard-app .trash-btn{
    border: none;
    padding: 0;
    color:#F55F6E;
    background-color:#f5f5f5;
}


.piq-body .dashboard-app .scroll-area{
    /* height: 450px;
    overflow-x: hidden;*/
    overflow-y: auto;
}

.piq-body .dashboard-app .table-hr{
    color: #373737;
    font-size: 16px;
}

.piq-body .dashboard-app .table td{
    font-weight: 400;
}


/* width */
.piq-body .dashboard-app .scroll-area::-webkit-scrollbar {
width: 7px;
}

/* Track */
.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-track {
box-shadow: inset 0 0 2px transparent;
border-radius: 5px;
padding: 20px;
}

/* Handle */
.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-thumb {
background: #6caad9;
border-radius: 10px;
}

/* Handle on hover */
.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-thumb:hover {
background: #69b9f6;
}

.piq-body .campaign-card-rounded{
    border-radius: 12px !important;
    background-color: #cde2f3 !important;
    border: none!important;
}

.piq-body .campaign-input-rounded{
    border-radius: 8px;
    background-color: #DCEAF7;
    font-size: 18px;
    font-weight: 600;
    border: none;
    padding: 10px;
    color: #797979;
}
.piq-body .campaign-input-rounded:focus {
    outline: none !important;
    border-color: #ccc !important;
    box-shadow: none !important;
  }

.piq-body .campaign-button-rounded{
    background-color: #010148;
    color: #ffffff;
    border-radius: 9px;
    font-weight: 600;
    font-size: 16px;
    padding: 8px;
    border: none;
}

.piq-body .upload-document-text{
    margin-top: .25rem;
    font-size: 22px;
    color: #3b3b3b;
    font-weight: 500;
}



.piq-body .new-campaign-heading{
    font-size: 22px;
    font-weight: 600;
}

.piq-body .dashboard-nav .brand-logo {
    font-family: "IBM Plex Sans", sans-serif;
    font-weight: bold;
    font-size: 20px;
    display: flex;
    color: #515151;
    align-items: center;
}

.piq-body .dashboard-nav .brand-logo:focus, .piq-body .dashboard-nav .brand-logo:active, .piq-body .dashboard-nav .brand-logo:hover {
    color: #dbdbdb;
    text-decoration: none;
}

.piq-body .dashboard-nav .brand-logo i {
    color: #d2d1d1;
    font-size: 27px;
    margin-right: 10px;
}

.piq-body .dashboard-nav-list {
    /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
    display: flex;
    /* -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column; */
    flex-direction: column;
}

.piq-body .dashboard-nav-item {
    min-height: 56px;
    padding: 8px 20px 8px 70px;
    /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
    display: flex;
    /* -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center; */
    align-items: center;
    letter-spacing: 0.02em;
    transition: ease-out 0.5s;
}

.piq-body .dashboard-nav-item i {
    width: 36px;
    font-size: 19px;
    margin-left: -40px;
}

.piq-body .dashboard-nav-item:hover {
    background: rgba(255, 255, 255, 0.04);
}

.active {
    background: rgba(0, 255, 221, 0.1);
}

.piq-body .dashboard-nav-dropdown {
    display: flex;
    flex-direction: column;
}

.piq-body .dashboard-nav-dropdown.show {
    background: rgba(255, 255, 255, 0.04);
}

.piq-body .dashboard-nav-dropdown.show > .piq-body .dashboard-nav-dropdown-toggle {
    font-weight: bold;
}

.piq-body .dashboard-nav-dropdown.show > .piq-body .dashboard-nav-dropdown-toggle:after {
    transform: none;
}

.piq-body .dashboard-nav-dropdown.show > .piq-body .dashboard-nav-dropdown-menu {
    display: flex;
}

.piq-body .dashboard-nav-dropdown-toggle:after {
    content: "";
    margin-left: auto;
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid rgba(81, 81, 81, 0.8);
    transform: rotate(90deg);
}

.piq-body .dashboard-nav .piq-body .dashboard-nav-dropdown-toggle:after {
    border-top-color: rgba(255, 255, 255, 0.72);
}

.piq-body .dashboard-nav-dropdown-menu {
    display: none;
    flex-direction: column;
}

.piq-body .dashboard-nav-dropdown-item {
    min-height: 40px;
    padding: 8px 20px 8px 70px;
    /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
    display: flex;
    /* -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center; */
    align-items: center;
    transition: ease-out 0.5s;
}

.piq-body .dashboard-nav-dropdown-item:hover {
    background: rgba(255, 255, 255, 0.04);
}

.piq-body .dashboard-app .menu-toggle {
    /* position: relative;
    width: 42px;
    height: 42px; */
    /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
    /* display: flex; */
    /* -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center; */
    /* justify-content: center; */
    color: #443ea2;
}

.piq-body .dashboard-app .menu-toggle:hover, .piq-body .dashboard-app .menu-toggle:active, .piq-body .dashboard-app .menu-toggle:focus {
    text-decoration: none;
    color: #875de5;
}

.piq-body .dashboard-app .menu-toggle i {
    font-size: 20px;
}
.piq-body .dashboard-app .text-dark-Campaigns{
    font-weight: 700;
}

.piq-body .dashboard-toolbar {
    /*background-color: #dfdfdf;*/
    width: 14px;
    padding: 8px 27px;
    /* min-height: 84px; */
    /* display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox; */
    /* display: flex; */
    /* -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center; */

    /* position: fixed; */
    /* top: 0;
    right: 0;
    left: 0;
    z-index: 1000; */
    /* display: none; */
    justify-content: center;
    display: flex;
}

/* .nav-item-divider {
    height: 1px;
    margin: 1rem 0;
    overflow: hidden;
    background-color: rgba(236, 238, 239, 0.3);
} */

/* Basic styling for the drag and drop area */
.piq-body #drag-and-drop-campaign {
    cursor: pointer;
    transition: background-color 0.3s ease;
    border: 2px dashed #f2f5fa;
}

/* Style for the overlay when dragging over */
.piq-body #drag-and-drop-campaign.dragover {
    border: 2px dashed #ccc;
    background-color: #dfdfdf42; /* Light blue overlay */
}


/* Media Query */

@media (min-width: 991px) {
    .piq-body .dashboard-app {
        margin-left: 238px;
    }

    .piq-body .dashboard-compact .dashboard-app {
        margin-left: 0;
    }
}


@media (max-width: 768px) {
    .piq-body .dashboard-content {
        padding: 15px 0px;
    }
}

@media (max-width: 991px) {
    .piq-body .dashboard-nav {
        display: none;
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        z-index: 1070;
    }

    .piq-body .dashboard-nav.mobile-show {
        display: block;
    }

    .piq-body .dashboard-app {
        border-radius: 0px;
    }



}

@media (max-width: 991px) {
    .piq-body .dashboard-nav header .piq-body .dashboard-app .menu-toggle {
        /* display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox; */
        display: flex;
    }
}

@media (min-width: 991px) {
    .piq-body .dashboard-app .dashboard-toolbar {
        left: 238px;
    }

    .piq-body .dashboard-compact .dashboard-app .dashboard-toolbar {
        left: 0;
    }
}

@media (min-width: 991px) {
    .piq-body .dashboard-app .dashboard-toolbar {
        display: none;
    }

}


@media only screen and (max-width: 768px) {
		.piq-body #drag-and-drop-campaign > div.mx-auto.p-4
	{
		padding: 0px !important;
	}

	.piq-body #drag-and-drop-campaign .upload-document-text
	{
		font-size:14px;
	}

	.piq-body #drag-and-drop-campaign > div.mx-auto.p-4 .justify-content-center img
	{
		width: 40px!important;
	}

	.piq-body .dashboard-app .scroll-area.ps-4 {
		    padding-left: 0px !important;
		}

	.piq-body .dashboard-app .scroll-area.pe-4 {
		padding-right: 0px !important;
	}

	.piq-body .dashboard-app h3.form-label.text-dark {
		font-size: 18px;
    text-align: center;
	}

	.piq-body .dashboard-app > div.p-4 {
		padding:10px!important;
	}

	.piq-body #campaign-box-header-titles
	{
		display:block!important;
		text-align:center;
	}

	.piq-body #campaign-box-header-titles .title-right
	{
		margin-right:0px!important;
	}


}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,sBAAsB;;AAEtB;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;;AAE7B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;;AAE7B;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,UAAU;AACd;;;AAGA,cAAc;AACd;;;;;;;;;;;;;;;;;;;;;;;;GAwBG;AACH;;;;;;;;;;;GAWG;;;;;;AAMH;;;;;;;;;;;;;;;;;GAiBG;;AAEH;;;;;;;;;;;;;;GAcG;;AAEH;IACI,aAAa;IACb,iBAAiB;CACpB,sBAAsB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;;;GAGG;;AAEH;IACI,gBAAgB;IAChB,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;IAGI,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;;;GAGG;;AAEH;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;;;;;AAMA;IACI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;CACjB,cAAc;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;;;AAIA;IACI,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,uBAAuB;AAC3B;AACA;IACI,qBAAqB;AACzB;;;;;;;AAOA;;;GAGG;;AAEH;;IAEI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,+DAA+D;IAC/D,cAAc;IACd,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,aAAa;IACb,wBAAwB;AAC5B;;;AAGA;IACI;wBACoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA,UAAU;AACV;AACA,UAAU;AACV;;AAEA,UAAU;AACV;AACA,qCAAqC;AACrC,kBAAkB;AAClB,aAAa;AACb;;AAEA,WAAW;AACX;AACA,mBAAmB;AACnB,mBAAmB;AACnB;;AAEA,oBAAoB;AACpB;AACA,mBAAmB;AACnB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,cAAc;AAClB;AACA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,2BAA2B;EAC7B;;AAEF;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;;;AAIA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;IACjB,eAAe;IAIf,aAAa;IACb,cAAc;IAId,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;;2BAEuB;IACvB,aAAa;IACb;;;iCAG6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B;;2BAEuB;IACvB,aAAa;IACb;;6BAEyB;IACzB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IAII,aAAa;IAKb,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IAGI,eAAe;AACnB;;AAEA;IAII,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,mCAAmC;IACnC,2CAA2C;IAG3C,wBAAwB;AAC5B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IAKb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B;;2BAEuB;IACvB,aAAa;IACb;;6BAEyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI;;mBAEe;IACf;;2BAEuB;IACvB,mBAAmB;IACnB;;;;;;4BAMwB;IACxB,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB;;2BAEuB;IACvB,mBAAmB;IACnB;;;0BAGsB;;IAEtB,qBAAqB;IACrB;;;oBAGgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;;;;;GAKG;;AAEH,6CAA6C;AAC7C;IACI,eAAe;IACf,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA,6CAA6C;AAC7C;IACI,uBAAuB;IACvB,2BAA2B,EAAE,uBAAuB;AACxD;;;AAGA,gBAAgB;;AAEhB;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;AACJ;;;AAGA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,eAAe;QACf,MAAM;QACN,QAAQ;QACR,OAAO;QACP,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;;;AAIJ;;AAEA;IACI;QACI;;+BAEuB;QACvB,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,OAAO;IACX;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;AAEJ;;;AAGA;EACE;;EAEA,uBAAuB;CACxB;;CAEA;;EAEC,cAAc;CACf;;CAEA;;EAEC,qBAAqB;CACtB;;CAEA;MACK,4BAA4B;EAChC;;CAED;EACC,6BAA6B;CAC9B;;CAEA;EACC,eAAe;IACb,kBAAkB;CACrB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;;EAEC,uBAAuB;EACvB,iBAAiB;CAClB;;CAEA;;EAEC,0BAA0B;CAC3B;;;AAGD","sourcesContent":[".piq-body {\n    margin: 0;\n    font-family: \"IBM Plex Sans\", sans-serif;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #515151;\n    text-align: left;\n    background-color: #010148;\n    min-height: 100vh;\n}\n\n/* Signup and Singin */\n\n.piq-body .card-rounded{\n    border-radius: 15px;\n}\n\n.piq-body .input-rounded{\n    border-radius: 8px;\n    background-color: #f8f8f8;\n\n}\n\n.piq-body .button-rounded{\n    border-radius: 8px;\n    background-color: #4040dd;\n\n}\n\n.piq-body .anchor-button-color{\n    color: #4040dd;\n    text-decoration: none;\n}\n\n.piq-body .anchor-color{\n    color: #4040dd;\n}\n\n.piq-body .contactInfo-btn-rounded-circle{\n    border: 3px solid black;\n    border-radius: 50px;\n    font-size: 7px;\n    margin-top: 10px;\n    margin-right: 10px;\n    padding: 6px;\n}\n.piq-body .contactInfo-btn-rounded-circle.btn-close {\n    opacity: 1;\n}\n\n\n/* dashboard */\n/*\n.piq-body nav {\n    display: block;\n}\n\n.piq-body h1, h2, h3, h4, h5, h6 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n}\n\n.piq-body p {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\n\n.piq-body a {\n    color: #3f84fc;\n    text-decoration: none;\n    background-color: transparent;\n}\n\n.piq-body a:hover {\n    color: #0458eb;\n    text-decoration: underline;\n} */\n/*\n.piq-body h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {\n    font-family: \"IBM Plex Sans\", sans-serif;\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\n.piq-body h1, .h1 {\n    font-size: 2.5rem;\n    font-weight: normal;\n} */\n\n\n\n\n\n/* .piq-body .dashboard-app .card {\n    position: relative;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    min-width: 0;\n    word-wrap: break-word;\n    background-color: #fff;\n    background-clip: border-box;\n    border: 1px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0;\n} */\n\n/* .piq-body .card-body {\n    -webkit-box-flex: 1;\n    -webkit-flex: 1 1 auto;\n    -ms-flex: 1 1 auto;\n    flex: 1 1 auto;\n    padding: 1.25rem;\n}\n\n.piq-body .card-header {\n    padding: 0.75rem 1.25rem;\n    margin-bottom: 0;\n    background-color: rgba(0, 0, 0, 0.03);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n    text-align: center;\n} */\n\n.piq-body .dashboard {\n    display: flex;\n    min-height: 100vh;\n\tflex-direction: column;\n}\n\n.piq-body .dashboard-app {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 2;\n    background: white;\n    border-radius: 30px 0px 0px 30px;\n}\n\n/* .dashboard-content {\n    flex-grow: 2;\n    padding: 25px;\n} */\n\n.piq-body .dashboard-nav {\n    min-width: 238px;\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    overflow: auto;\n    background-color: #010148;\n    display: flex;\n    flex-direction: column;\n}\n\n.piq-body .dashboard-toolbar,\n.piq-body .brand-logo,\n.piq-body .dashboard-nav-list:not(.sign-out-nav) {\n    flex-shrink: 0;\n}\n.piq-body .dashboard-nav-list.sign-out-nav {\n    margin-top: auto;\n}\n\n/* .piq-body .dashboard-compact .dashboard-nav {\n    display: none;\n} */\n\n.piq-body .dashboard-nav header {\n    display: flex;\n    justify-content: center;\n    width: 14px;\n}\n\n/* .piq-body .dashboard-nav header .piq-body .dashboard-app .menu-toggle {\n    display: none;\n    margin-right: auto;\n} */\n\n.piq-body .dashboard-nav a {\n    color: #fff;\n    text-decoration: none;\n}\n\n.piq-body .dashboard-nav a:hover {\n    text-decoration: none;\n}\n\n\n\n\n\n.piq-body .campaignInfo-ok-btn{\n    color: #fff;\n    background-color: #110F75;\n    padding: 5px 20px 5px 20px;\n    text-align: center;\n    border-radius: 7px;\n    border:2px solid #110F75;\n    font-weight: 700;\n}\n\n.piq-body .uploadCsv-modalContent{\n    background-color: #010148 ;\n    border-radius: 5px !important;\n}\n\n.piq-body .uploadCsv-input-rounded{\n    font-weight: 500;\n    border: none;\n    color: #797979;\n\tcursor:pointer;\n}\n\n.piq-body .uploadCsv-file-label{\n    font-weight: 400;\n    color: #ffff;\n}\n\n\n\n.piq-body .campaignInfo-modalContent{\n    border: 4px solid #2c3e7e !important;\n    border-radius: 20px !important;\n}\n\n.piq-body .campaignInfo-modalLabel{\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.piq-body .campaignInfo-save-btn{\n    background-color: #5BE7CD;\n    color: #1c1c1c;\n    padding-left: 20px;\n    padding-right: 20px;\n    font-weight: 500;\n    border: 1px solid #5BE7CD;\n}\n\n.piq-body .campaignInfo-btn-rounded-circle{\n    border: 3px solid #2c3e7e !important;\n    border-radius: 50px !important;\n    font-size: 7px !important;\n    margin-top: 10px !important;\n    margin-right: 10px !important;\n    padding: 6px !important;\n}\n.piq-body .campaignInfo-btn-rounded-circle.btn-close {\n    opacity: 1 !important;\n}\n\n\n\n\n\n\n/* .piq-body .dashboard-nav {\n    background-color: #010148;\n\n} */\n\n.piq-body .dashboard-app .status-pill\n{\n    font-weight: 700;\n    font-size: 14px;\n    display: inline-block;\n    min-width: 150px;\n}\n\n.piq-body .dashboard-app .button-bg-warning-danger{\n    background-color: #F55F6E;\n}\n.piq-body .dashboard-app .button-bg-warning{\n    background-color: #F5A065;\n}\n.piq-body .dashboard-app .button-bg-info{\n    background-color: #5BE7CD;\n}\n\n.piq-body .dashboard-app .cl-filter-icon label{\n    font-weight: 600;\n}\n\n.piq-body .dashboard-app .cl-filter-icon span img\n{\n    max-width: 26px;\n    border-radius: 8px;\n    margin-right: 7px;\n}\n\n.piq-body .dashboard-app .cl-internal-area-container{\n    background-color:#f2f5fa;\n    border-radius: 15px;\n    min-height: calc(100vh - 220px);\n}\n\n.piq-body .dashboard-app .cl-heading-border {\n    border: 0;\n    height: 4px !important;\n    background: linear-gradient(to right, #6caad9 28%, #b0c8df 28%);\n    margin: 10px 0;\n    opacity: 1;\n}\n\n.piq-body .dashboard-app .share-square-btn{\n    border: none;\n    padding: 0;\n    color:#4AA2E9;\n    background-color:#f5f5f5;\n}\n\n.piq-body .dashboard-app .trash-btn{\n    border: none;\n    padding: 0;\n    color:#F55F6E;\n    background-color:#f5f5f5;\n}\n\n\n.piq-body .dashboard-app .scroll-area{\n    /* height: 450px;\n    overflow-x: hidden;*/\n    overflow-y: auto;\n}\n\n.piq-body .dashboard-app .table-hr{\n    color: #373737;\n    font-size: 16px;\n}\n\n.piq-body .dashboard-app .table td{\n    font-weight: 400;\n}\n\n\n/* width */\n.piq-body .dashboard-app .scroll-area::-webkit-scrollbar {\nwidth: 7px;\n}\n\n/* Track */\n.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-track {\nbox-shadow: inset 0 0 2px transparent;\nborder-radius: 5px;\npadding: 20px;\n}\n\n/* Handle */\n.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-thumb {\nbackground: #6caad9;\nborder-radius: 10px;\n}\n\n/* Handle on hover */\n.piq-body .dashboard-app .scroll-area::-webkit-scrollbar-thumb:hover {\nbackground: #69b9f6;\n}\n\n.piq-body .campaign-card-rounded{\n    border-radius: 12px !important;\n    background-color: #cde2f3 !important;\n    border: none!important;\n}\n\n.piq-body .campaign-input-rounded{\n    border-radius: 8px;\n    background-color: #DCEAF7;\n    font-size: 18px;\n    font-weight: 600;\n    border: none;\n    padding: 10px;\n    color: #797979;\n}\n.piq-body .campaign-input-rounded:focus {\n    outline: none !important;\n    border-color: #ccc !important;\n    box-shadow: none !important;\n  }\n\n.piq-body .campaign-button-rounded{\n    background-color: #010148;\n    color: #ffffff;\n    border-radius: 9px;\n    font-weight: 600;\n    font-size: 16px;\n    padding: 8px;\n    border: none;\n}\n\n.piq-body .upload-document-text{\n    margin-top: .25rem;\n    font-size: 22px;\n    color: #3b3b3b;\n    font-weight: 500;\n}\n\n\n\n.piq-body .new-campaign-heading{\n    font-size: 22px;\n    font-weight: 600;\n}\n\n.piq-body .dashboard-nav .brand-logo {\n    font-family: \"IBM Plex Sans\", sans-serif;\n    font-weight: bold;\n    font-size: 20px;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    color: #515151;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.piq-body .dashboard-nav .brand-logo:focus, .piq-body .dashboard-nav .brand-logo:active, .piq-body .dashboard-nav .brand-logo:hover {\n    color: #dbdbdb;\n    text-decoration: none;\n}\n\n.piq-body .dashboard-nav .brand-logo i {\n    color: #d2d1d1;\n    font-size: 27px;\n    margin-right: 10px;\n}\n\n.piq-body .dashboard-nav-list {\n    /* display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox; */\n    display: flex;\n    /* -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column; */\n    flex-direction: column;\n}\n\n.piq-body .dashboard-nav-item {\n    min-height: 56px;\n    padding: 8px 20px 8px 70px;\n    /* display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox; */\n    display: flex;\n    /* -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center; */\n    align-items: center;\n    letter-spacing: 0.02em;\n    transition: ease-out 0.5s;\n}\n\n.piq-body .dashboard-nav-item i {\n    width: 36px;\n    font-size: 19px;\n    margin-left: -40px;\n}\n\n.piq-body .dashboard-nav-item:hover {\n    background: rgba(255, 255, 255, 0.04);\n}\n\n.active {\n    background: rgba(0, 255, 221, 0.1);\n}\n\n.piq-body .dashboard-nav-dropdown {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.piq-body .dashboard-nav-dropdown.show {\n    background: rgba(255, 255, 255, 0.04);\n}\n\n.piq-body .dashboard-nav-dropdown.show > .piq-body .dashboard-nav-dropdown-toggle {\n    font-weight: bold;\n}\n\n.piq-body .dashboard-nav-dropdown.show > .piq-body .dashboard-nav-dropdown-toggle:after {\n    -webkit-transform: none;\n    -o-transform: none;\n    transform: none;\n}\n\n.piq-body .dashboard-nav-dropdown.show > .piq-body .dashboard-nav-dropdown-menu {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n.piq-body .dashboard-nav-dropdown-toggle:after {\n    content: \"\";\n    margin-left: auto;\n    display: inline-block;\n    width: 0;\n    height: 0;\n    border-left: 5px solid transparent;\n    border-right: 5px solid transparent;\n    border-top: 5px solid rgba(81, 81, 81, 0.8);\n    -webkit-transform: rotate(90deg);\n    -o-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n\n.piq-body .dashboard-nav .piq-body .dashboard-nav-dropdown-toggle:after {\n    border-top-color: rgba(255, 255, 255, 0.72);\n}\n\n.piq-body .dashboard-nav-dropdown-menu {\n    display: none;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n\n.piq-body .dashboard-nav-dropdown-item {\n    min-height: 40px;\n    padding: 8px 20px 8px 70px;\n    /* display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox; */\n    display: flex;\n    /* -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center; */\n    align-items: center;\n    transition: ease-out 0.5s;\n}\n\n.piq-body .dashboard-nav-dropdown-item:hover {\n    background: rgba(255, 255, 255, 0.04);\n}\n\n.piq-body .dashboard-app .menu-toggle {\n    /* position: relative;\n    width: 42px;\n    height: 42px; */\n    /* display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox; */\n    /* display: flex; */\n    /* -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center; */\n    /* justify-content: center; */\n    color: #443ea2;\n}\n\n.piq-body .dashboard-app .menu-toggle:hover, .piq-body .dashboard-app .menu-toggle:active, .piq-body .dashboard-app .menu-toggle:focus {\n    text-decoration: none;\n    color: #875de5;\n}\n\n.piq-body .dashboard-app .menu-toggle i {\n    font-size: 20px;\n}\n.piq-body .dashboard-app .text-dark-Campaigns{\n    font-weight: 700;\n}\n\n.piq-body .dashboard-toolbar {\n    /*background-color: #dfdfdf;*/\n    width: 14px;\n    padding: 8px 27px;\n    /* min-height: 84px; */\n    /* display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox; */\n    /* display: flex; */\n    /* -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center; */\n\n    /* position: fixed; */\n    /* top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1000; */\n    /* display: none; */\n    justify-content: center;\n    display: flex;\n}\n\n/* .nav-item-divider {\n    height: 1px;\n    margin: 1rem 0;\n    overflow: hidden;\n    background-color: rgba(236, 238, 239, 0.3);\n} */\n\n/* Basic styling for the drag and drop area */\n.piq-body #drag-and-drop-campaign {\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    border: 2px dashed #f2f5fa;\n}\n\n/* Style for the overlay when dragging over */\n.piq-body #drag-and-drop-campaign.dragover {\n    border: 2px dashed #ccc;\n    background-color: #dfdfdf42; /* Light blue overlay */\n}\n\n\n/* Media Query */\n\n@media (min-width: 991px) {\n    .piq-body .dashboard-app {\n        margin-left: 238px;\n    }\n\n    .piq-body .dashboard-compact .dashboard-app {\n        margin-left: 0;\n    }\n}\n\n\n@media (max-width: 768px) {\n    .piq-body .dashboard-content {\n        padding: 15px 0px;\n    }\n}\n\n@media (max-width: 991px) {\n    .piq-body .dashboard-nav {\n        display: none;\n        position: fixed;\n        top: 0;\n        right: 0;\n        left: 0;\n        bottom: 0;\n        z-index: 1070;\n    }\n\n    .piq-body .dashboard-nav.mobile-show {\n        display: block;\n    }\n\n    .piq-body .dashboard-app {\n        border-radius: 0px;\n    }\n\n\n\n}\n\n@media (max-width: 991px) {\n    .piq-body .dashboard-nav header .piq-body .dashboard-app .menu-toggle {\n        /* display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox; */\n        display: flex;\n    }\n}\n\n@media (min-width: 991px) {\n    .piq-body .dashboard-app .dashboard-toolbar {\n        left: 238px;\n    }\n\n    .piq-body .dashboard-compact .dashboard-app .dashboard-toolbar {\n        left: 0;\n    }\n}\n\n@media (min-width: 991px) {\n    .piq-body .dashboard-app .dashboard-toolbar {\n        display: none;\n    }\n\n}\n\n\n@media only screen and (max-width: 768px) {\n\t\t.piq-body #drag-and-drop-campaign > div.mx-auto.p-4\n\t{\n\t\tpadding: 0px !important;\n\t}\n\n\t.piq-body #drag-and-drop-campaign .upload-document-text\n\t{\n\t\tfont-size:14px;\n\t}\n\n\t.piq-body #drag-and-drop-campaign > div.mx-auto.p-4 .justify-content-center img\n\t{\n\t\twidth: 40px!important;\n\t}\n\n\t.piq-body .dashboard-app .scroll-area.ps-4 {\n\t\t    padding-left: 0px !important;\n\t\t}\n\n\t.piq-body .dashboard-app .scroll-area.pe-4 {\n\t\tpadding-right: 0px !important;\n\t}\n\n\t.piq-body .dashboard-app h3.form-label.text-dark {\n\t\tfont-size: 18px;\n    text-align: center;\n\t}\n\n\t.piq-body .dashboard-app > div.p-4 {\n\t\tpadding:10px!important;\n\t}\n\n\t.piq-body #campaign-box-header-titles\n\t{\n\t\tdisplay:block!important;\n\t\ttext-align:center;\n\t}\n\n\t.piq-body #campaign-box-header-titles .title-right\n\t{\n\t\tmargin-right:0px!important;\n\t}\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
